import React from "react";
import {gridConstants} from "./";

interface GridCellProps {
    children?: React.ReactNode;
    className?: string;
    large_columns?: string;
    large_offset?: string;
    medium_columns?: string;
    medium_offset?: string;
    small_columns?: string;
    small_offset?: string;
    handleClick?: () => void;
}

export const GridCell: React.FC<GridCellProps> = ({
                    children,
                    className ="",
                    large_columns = "",
                    large_offset = "",
                    medium_columns = "",
                    medium_offset = "",
                    small_columns = gridConstants.column.TWELVE,
                    small_offset = "",
                    handleClick
                }: GridCellProps) => {
    let classes = gridConstants.class.CELL;
    classes += className ? ` ${className}` : ``;

    classes += small_columns ? ` xsmall-${small_columns}` : ``;
    classes += medium_columns ? ` medium-${medium_columns}` : ``;
    classes += large_columns ? ` large-${large_columns}` : ``;

    classes += small_offset ? ` small-offset-${small_offset}` : ``;
    classes += medium_offset ? ` medium-offset-${medium_offset}` : ``;
    classes += large_offset ? ` large-offset-${large_offset}` : ``;

    const props = {
        children: children,
        className: classes,
        onClick: handleClick,
    }

    return handleClick ? <button {...props} /> : <div {...props} />;
};
